import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";

const Investment = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable
          name="Investment"
          title="Nhà Đầu Tư"
          whereQuery={{
            isInvestor: true,
          }}
          disableAdd
        />
      </Container>
    </div>
  );
};

export default Investment;
